import styled from "styled-components";

export const OnboardingDialogLogoBox = styled.div<{zIndex: number;}>`
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 11.8rem;
    height: 11.8rem;
    border-radius: 50%;
    border: 0.8rem solid ${({theme}) => theme.colors.brandSecondaryLight};
    background-color: ${({theme}) => theme.colors.background};
    overflow: hidden;
    z-index: ${({zIndex}) => zIndex};
    @media ${({theme}) => theme.mediaQuery.mAndBelow} {
        width: 9.2rem;
        height: 9.2rem;
        border-width: 0.6rem;
    }
`;